import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { closePopup } from '../../../actions/popup'
import * as ClearBlogDataResultCode from '../../../constants/setting/ClearBlogDataResultCode'

function AlreadyRequestMessage() {
  return (
    <div className="cont_layer">
      <p className="txt_popup">
        이미 데이터 삭제 작업이 진행중입니다.
      </p>
    </div>
  )
}

function JobAcceptedMessage({resultMessage}) {
  return (
    <div className="cont_layer">
      <strong className="tit_popup">데이터 삭제 확인</strong>
      <p className="txt_popup">
        블로그 데이터 삭제를 위해 로그인 아이디 <span className="txt_em">‘{resultMessage}’</span>로 인증메일이 발송되었습니다. 메일을 확인하여 데이터 삭제를 완료해 주세요.
      </p>
      <p className="txt_etc">
        데이터가 많을 경우 순차적으로 삭제가 진행되며 완료 후 안내 메일을 보내드립니다. 삭제가 진행되는 동안 블로그 접속이 원활하지 않을 수 있습니다.
      </p>
    </div>
  )
}

function PopupMessage({resultCode, resultMessage}) {
  switch (resultCode) {
    case ClearBlogDataResultCode.ALREADY_REQUESTED:
      return <AlreadyRequestMessage />
    case ClearBlogDataResultCode.JOB_ACCEPTED:
      return <JobAcceptedMessage resultMessage={resultMessage} />
    default:
      return null
  }
}

export default function ClearDataResultPopup() {
  const popupOpened = useSelector(state => state.popup.clearDataResultPopupOpened)
  const resultCode = useSelector(state => state.popup.clearDataResultCode)
  const resultMessage = useSelector(state => state.popup.clearDataResultMessage)
  const dispatch = useDispatch()

  function handlePopupClose() {
    dispatch(closePopup())
  }

  return (
    <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-112px', display: popupOpened?'block':'none'}}>
      <div className="inner_blog_layer inner_blog_layer1">
        <PopupMessage resultCode={resultCode} resultMessage={resultMessage} />

        <div className="fld_btn">
          <button type="submit" className="btn_default" onClick={(e) => handlePopupClose()}>확인</button>
        </div>
        <label className="lab_btn lab_close">
          <span className="ico_blog">레이어 닫기</span>
          <input type="button" className="btn_g" value="닫기" onClick={(e) => handlePopupClose()}/>
        </label>
      </div>
    </div>
  )
}
